<app-table-header
      (reload)="onRefreshList(false)"
      [loading]="loading"
      [withExportOption]="!!data.info.exportTableName"
      [withClearCache]="true"
      (exportBtnClicked)="exportBtnClicked()"
      (clearCache)="clearCache()"
      >
      <div class="storestocks-filters">
        <label
          nz-checkbox
          class="table-filter-check"
          [(ngModel)]="filter1"
          (ngModelChange)="filter2 = false; filter3 = false; onRefreshList()"
        >Abpackliste Lagerbestand < 5</label>
        <label
          nz-checkbox
          class="table-filter-check"
          [(ngModel)]="filter2"
          (ngModelChange)="filter1 = false; filter3 = false; onRefreshList()"
        >Abpackliste Lagerbestand < 25</label>
        <label
          nz-checkbox
          class="table-filter-check"
          [(ngModel)]="filter3"
          (ngModelChange)="filter1 = false; filter2 = false; onRefreshList()"
        >Nicht relevant für Abfüllliste</label>
        <label
          nz-checkbox
          class="table-filter-check"
          [(ngModel)]="showEmptyMhd"
          (ngModelChange)="onRefreshList()"
        >Nur leere MHD anzeigen</label>
        <div class="storestocks-filters__mhd">
          <span>MHD ist</span>
          <nz-select
            [(ngModel)]="mhdOperator"
            (ngModelChange)="onRefreshList()"
            nzPlaceHolder="Vergleich"
            [nzDisabled]="showEmptyMhd"
            aria-label="MHD-Vergleich"
          >
            <nz-option nzValue="lt" nzLabel="vor"></nz-option>
            <nz-option nzValue="gt" nzLabel="nach"></nz-option>
            <nz-option nzValue="le" nzLabel="am oder vor"></nz-option>
            <nz-option nzValue="ge" nzLabel="am oder nach"></nz-option>
          </nz-select>
          <nz-date-picker
            [(ngModel)]="mhdDate"
            (ngModelChange)="onRefreshList()"
            [nzDisabled]="showEmptyMhd"
            aria-label="MHD-Datum"
          ></nz-date-picker>
        </div>
      </div>

        <app-table-search-bar (search)="search($event)" [searchValue]="currentSearch"></app-table-search-bar>
</app-table-header>

<nz-table appColumnLayout
        #tableRef
        nzShowSizeChanger
        [nzScroll]="{ x: tableMaxWidth }"
        [nzData]="data.results"
        [nzLoading]="loading"
        [nzTotal]="data.info.totalResults"
        [nzFrontPagination]="false"
        [nzPageSize]="pageSize"
        [nzPageIndex]="data.info.page"
        (nzQueryParams)="onQueryParamsChange($event)"
        appKeepState
        id="store-stocks-list-table"
        >
        <thead>
          <tr>
            <th nzColumnKey="id" [nzSortFn]="true" nzWidth="75px">#ID</th>
            <th nzWidth="200px" nzColumnKey="orderNumber" [nzSortFn]="true">Bestellnummer</th>
            <th nzColumnKey="articleName" [nzSortFn]="true"  nzWidth="250px">Artikel</th>
            <th nzColumnKey="name" [nzSortFn]="true"  nzWidth="250px">Variante</th>
            <th nzColumnKey="mhd" [nzSortFn]="true"  nzWidth="250px">MHD</th>
            <th nzWidth="150px" nzColumnKey="inStock" [nzSortFn]="true">Lagerbestand</th>
            <th nzWidth="150px" nzColumnKey="plannedProductionState" [nzSortFn]="true">Geplante Produktion</th>
            <th nzWidth="150px" nzColumnKey="bulkContainerState" [nzSortFn]="true">
              Großgebinde
            </th>
            <th nzColumnKey="ean" [nzSortFn]="true" nzWidth="140px">EAN</th>
            <th nzColumnKey="actions" nzRight nzWidth="100px"></th>
          </tr>
        </thead>
        <tbody>
          @for (storeStocksListItem of data.results; track storeStocksListItem) {
            <tr>
              <td>{{storeStocksListItem.id}}</td>
              <td>{{storeStocksListItem.orderNumber}}</td>
              <td>{{storeStocksListItem.articleName}}</td>
              <td>{{storeStocksListItem.name}}</td>
              <td>{{storeStocksListItem.mhd | dateFormat}}</td>
              <td>{{storeStocksListItem.inStock}}</td>
              <td>{{storeStocksListItem.plannedProductionState}}</td>
              <td>
                {{(storeStocksListItem.bulkContainerState | productionUnit:true) }}
              </td>
              <td>{{storeStocksListItem.ean}}</td>
              <td nzRight>
                <div class="actions" style="align-items: center;">
                  <app-add-edit-article-modal (refresh)="onRefreshList(false)" #addEditArticleModalComponent>
                    <span trigger>
                      <app-icon-button
                        icon="edit"
                        [ariaLabel]="'Artikel bearbeiten: ' + storeStocksListItem.articleName"
                        (pressed)="openModal(storeStocksListItem.articleId, storeStocksListItem.articleName + ' ' + storeStocksListItem.name)"
                      ></app-icon-button>
                    </span>
                  </app-add-edit-article-modal>
                  @if (storeStocksListItem.productionArticleId) {
                    <app-icon-button
                      icon="shopping-cart"
                      [ariaLabel]="'Großgebinde öffnen: ' + storeStocksListItem.articleName"
                      [link]="'/bulk-containers/bulk-container/' + storeStocksListItem.productionArticleId"
                      [queryParams]="{ tab: 'deliveries' }"
                    ></app-icon-button>
                  }
                </div>
              </td>
            </tr>
          }

        </tbody>
      </nz-table>
      <app-export-table-modal #exportTableModalComponent></app-export-table-modal>
